<template>
  <div class="contain">
    <header style="padding: 0 20px">
      <el-tabs v-model="activeName" @tab-click="activeTab" class="bg-white">
        <el-tab-pane label="公告" name="1" />
        <el-tab-pane label="站内信" name="2" />
        <el-tab-pane label="下架产品通知" name="3" />
      </el-tabs>
      <div class="form f bg-white">
        <!-- <el-select
          v-if="activeName == 3"
          v-model="productType"
          placeholder="请选择"
          @change="changeType"
          style="margin-right:20px"
        >
          <el-option label="按SPU" value="spu" />
          <el-option label="按SKU" value="sku" />
        </el-select> -->
         <el-radio-group v-if="activeName == 3" v-model="productType" @change="changeType" style="margin-bottom: 20px;">
          <el-radio-button label="spu">按SPU</el-radio-button>
          <el-radio-button label="sku">按SKU</el-radio-button>
        </el-radio-group>
      </div>
      <div class="f--c" style="margin-bottom: 10px">
        <el-button
          type="primary"
          @click="add"
          >新增</el-button
        >
        <el-input
          :placeholder="(activeName == 3 && (productType === 'spu' || productType === 'sku')) ? '支持批量搜索(英文逗号分隔)': '请输入内容'"
          v-model="searchContent"
          class="input-with-select"
          @change="resetPage"
          style="width:400px;margin-left:20px"
        >
          <el-select
            v-model="searchString"
            slot="prepend"
            placeholder="请选择"
            @change="resetPage"
            style="width:100px"
          >
            <el-option v-if="activeName == 3 && productType ==='spu'" label="SPU" value="spuCodes" />
            <el-option v-if="activeName == 3 && productType ==='sku'" label="SKU" value="skuCodes" />
            <el-option v-else label="标题" value="title" />
            <el-option label="创建人" value="creater" />
            <el-option label="更新人" value="modifier" />
          </el-select>
        </el-input>
      </div>
    </header>
    <div class="list bg-white">
      <notice-table v-if="activeName == 1" :list="tableData" :loading="listLoading" @deleteRow="getList()" />
      <mail-table v-if="activeName == 2" :list="tableData" :loading="listLoading" @revocation="getList()" />
      <offproduct-table v-if="activeName == 3" :list="tableData" :loading="listLoading" />
      <!-- <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          type="index"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column prop="title" align="center" label="标题"></el-table-column>
        <el-table-column align="center" label="人员信息">
          <template slot-scope="scope">
            创建人: {{ scope.row.creater }}
          </template>
        </el-table-column>
        <el-table-column label="时间信息" align="center">
          <template slot-scope="scope">
            <div>创建时间: {{ scope.row.createDate | dateFormat }}</div>
            <div>发送时间: {{ scope.row.sendTime | dateFormat }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              @click="editRow(scope.row)"
              type="text"
              size="small"
              style="margin-right: 8px"
              >编辑</el-button
            >
            <el-popconfirm
              title="确定删除此条数据吗"
              icon-color="red"
              @confirm="deleteRow(scope.row)"
            >
              <el-button
                slot="reference"
                type="text"
                size="small"
                style="color: red"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table> -->
      <!-- 页脚 -->
    </div>
    <footer class="common-footer">
      <el-pagination background :current-page="searchParams.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="searchParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </footer>
    <off-product ref="offProduct" @success="productTakeDownList()"/>
  </div>
</template>

<script>
import API from "@/api"
import MailTable from './components/MailTable.vue'
import NoticeTable from './components/NoticeTable.vue'
import OffproductTable from './components/OffproductTable.vue'
import OffProduct from '../add/OffProduct.vue'
export default {
  name: 'operation_newFunction',
  components: { MailTable, OffproductTable, NoticeTable, OffProduct },
  data() {
    return {
      searchString: 'title',
      searchContent: undefined,
      tableData: [],
      searchParams: {
        pageSize: 20,
        pageNumber: 1,
      },
      total: 0,
      activeName: '1',
      listLoading: false,
      productType: 'spu'
    }
  },
  created() {
    if (this.$route.query.type) this.activeName = this.$route.query.type
    this.getList()
  },
  methods: {
    add() {
      if (this.activeName == 3) this.$refs.offProduct.show(this.productType)
      else this.$router.push(`/operation/newFunction/add?type=${this.activeName}`)
    },
    
    getParams() {
      const params = Object.assign({}, this.searchParams)
      if (this.searchContent) params[this.searchString] = this.searchContent
      return params
    },
    getList() {
      this.listLoading = true
      const params = this.getParams()
      params.type = +this.activeName
      API.newFunctionStationLetterList(params).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    // 获取下架产品通知列表
    productTakeDownList() {
      this.listLoading = true
      const params = this.getParams()
      params.takeDownType = this.productType === 'spu' ? 1 : 2
      if (this.searchContent && (this.searchString === 'spuCodes' || this.searchString === 'skuCodes')) {
        params[this.searchString] = this.searchContent.split(',')
      }
      API.productTakeDownList(params).then(({ data }) => {
        this.tableData = (data && data.list) || []
        this.total = data.total || 0
      }).finally(() => {
        this.listLoading = false
      })
    },
    resetPage() {
      this.searchParams.pageNumber = 1
      if (this.activeName == 3) this.productTakeDownList()
      else this.getList()
    },
    changeType(value) {
      this.searchString = value === 'sku' ? 'skuCodes' : 'spuCodes'
      this.productTakeDownList()
    },
    activeTab() {
      this.productType = 'spu'
      this.searchString = this.activeName == 3 ? 'spuCodes' : 'title'
      this.resetPage()
    },

    // 每页显示条数改变时的回调
    handleSizeChange(value) {
      this.searchParams.pageSize = value
      if (this.activeName == 3) this.productTakeDownList()
      else this.getList()
    },

    // 当前页发生改变时触发的回调
    handleCurrentChange(value) {
      this.searchParams.pageNumber = value
      if (this.activeName == 3) this.productTakeDownList()
      else this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>
.contain {
  min-width: 1400px;
  background-color: #fff;
  .form {
    padding: 10px 0;
    padding-bottom: 0;
    .input-with-select {
      width: 400px;
    }
    .input-with-select /deep/ .el-input-group__prepend {
      background-color: #fff;
      width: 120px;
    }
    .el-select .el-input {
      width: 130px;
    }
  }
  .list {
    padding: 10px 20px;
    height: calc(100vh - 270px);
  }

  .common-footer {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 10px;
  }
}
</style>